module.exports = __webpack_public_path__ + "img/de-puydt.88d4c7c3.jpg";